<template>
  <div>
    <v-layout wrap justify-right>
      <v-flex xs12 align-self-center text-left py-2>
        <span style="font-family: opensansbold; font-size: 16px; color: black">Sales Statistics</span>
      </v-flex>
      <v-flex pr-1>
        <v-select
        class="ROUND"
          background-color="#f5bf42"
          dark
          solo
          dense
          :items="yearList"
          v-model="year1"
        ></v-select>
      </v-flex>
      <v-flex pl-sm-1 pr-1 pr-sm-0>
        <v-select
         class="ROUND"
          background-color="#FC4B4B"
          dark
          solo
          dense
          :items="yearList"
          v-model="year2"
          
        ></v-select>
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <PageLoader v-bind:storage="appLoading" v-bind:contain="true" />
      <v-flex v-if="flag">
        <apexchart
          type="bar"
          height="430"
          :options="chartOptions"
          :series="series"
        ></apexchart>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      flag: false,
      years: ["2016", "2017", "2018", "2019", "2020", "2021"],
      year1: "2020",
      year2: "2021",
      startYear: 2021,
      currentYear: null,
      // lasts:2029,
      yearList: [],
      // currentYear: null,
      fromDate: new Date(),
      series: [
        {
          name: "sales",
          data: [],
        },
        {
          name: "sales",
          data: [],
        },
      ],
      chartOptions: {
        colors: ["#FFD341", "#FC4B4B"],
        chart: {
          type: "bar",
          height: 430,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            dataLabels: {
              position: "top",
            },
          },
        },
        dataLabels: {
          enabled: false,
          offsetX: -6,
          style: {
            fontSize: "12px",
            colors: ["#fff"],
          },
        },
        stroke: {
          show: true,
          width: 1,
          colors: ["#fff"],
        },
        tooltip: {
          shared: true,
          intersect: false,
        },
        xaxis: {
          categories: [],
        },
      },
    };
  },
  beforeMount() {
    this.currentYear = this.fromDate.getFullYear();
    for (let i = this.startYear - 6; i <= this.currentYear; i++) {
      this.yearList.push(i);
    }
    this.year1 = this.currentYear - 1;
    this.year2 = this.currentYear;
    // this.getData();
  },
  watch: {
    // currentYear() {
    //   this.getData()
    // },
    year1() {
      this.getData();
    },
    year2() {
      this.getData();
    },
  },
  methods: {
    getData() {
      this.appLoading = true;
      this.flag = false;
      // this.chartOptions.xaxis.categories = [];
      // this.series[0].name = "";
      // this.series[0].data = [];
      // this.series[1].data = [];
      // this.series[1].name = "";
      axios({
        method: "POST",
        url: "seller/dashboard/graph",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          year1: this.year1,
          year2: this.year2,
        },
      })
        .then((response) => {
          if (response.data.status) {
            // this.chartOptions.xaxis.categories = [];
            // this.series[0].data = [];
            // this.series[1].data = [];
            for (let i = 0; i < response.data.data.length; i++) {
              if (i == 0) {
                this.chartOptions.xaxis.categories = [];
                this.series[0].name = "";
                this.series[0].data = [];
                this.series[1].data = [];
                this.series[1].name = "";
              }
              this.chartOptions.xaxis.categories.push(
                response.data.data[i].month
              );
              this.series[0].name = this.year1;
              this.series[0].data.push(
                response.data.data[i].year1_orders.toFixed()
              );
              this.series[1].name = this.year2;
              this.series[1].data.push(
                response.data.data[i].year2_orders.toFixed()
              );
            }
            // console.log("One=", this.series[0].data);
            this.flag = true;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })

        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.ROUND
{
  border-radius:20px !important;
}
</style>
